@if (!hasData) {
  <app-advisor-errorpage></app-advisor-errorpage>
}

@if (hasData) {
  <section class="intro">
    <h1 class="text-center">{{ 'heizcheck.auswerten.headline' | translate }}</h1>
    <p class="text-center">{{ 'heizcheck.auswerten.teaser' | translate }}</p>
    <div class="overview">
      <div class="grid-x">
        <div class="cell small-12 large-4">
          <strong [innerHTML]="'heizcheck.auswerten.section.consumption.headline' | translate"></strong>
          <div [class]="'resultmarker-' + getResult('consumption.overall')" [innerHTML]="getTextKey('entry.consumption') | translate"></div>
        </div>
        <div class="cell small-12 large-4">
          <strong [innerHTML]="'heizcheck.auswerten.section.energy.headline' | translate"></strong>
          <div [class]="'resultmarker-' + getResult('energy.overall')" [innerHTML]="getTextKey('entry.energy') | translate"></div>
        </div>
        <div class="cell small-12 large-4">
          <strong [innerHTML]="'heizcheck.auswerten.section.building.headline' | translate"></strong>
          <div [class]="'resultmarker-' + getResult('building.overall')" [innerHTML]="getTextKey('entry.building') | translate"></div>
        </div>
        <div class="cell small-12" [innerHTML]="getTextKey('entry.summary') | translate"></div>
      </div>
    </div>
    <div class="arrow no-print"><span>{{ 'heizcheck.auswerten.details' | translate }}</span></div>
  </section>
}

@if (hasData) {
  <section class="consumption">
    <h2 [innerHTML]="'heizcheck.auswerten.section.consumption.headline' | translate" class="box-headline"></h2>
    <p [innerHTML]="'heizcheck.auswerten.consumption.teaser' | translate:placeholder['consumption'] | safeHtml"></p>
    <div class="consumption-image">
      <div class="signal3">
        <span [innerHTML]="getTextKey('consumption.overall', 'label') | translate"></span><br>
        <span [class]="'resultmarker-' + getResult('consumption.overall')">{{sign(placeholder['consumption']['percent_rare'])}}{{placeholder['consumption']['percent']}}%</span>
      </div>
      <img src="/gfx/hec/apartment-building-grey-floor-orange.svg" alt="">
      <span class="label" [innerHTML]="'heizcheck.auswerten.consumption.average' | translate"></span>
    </div>
    <app-helptext [helptextId]="'help-costs'" [icon]="'icon-robot'" [buttontext]="'heizcheck.auswerten.consumption.help.costs.button'" [helptext]="'heizcheck.auswerten.consumption.help.costs.help'"></app-helptext>
    <div class="grid-x grid-margin-x section-result print-break-before">
      <div class="cell small-12 top">
        <p class="secondary" [class]="'resultmarker-' + getResult('consumption.overall')" [innerHTML]="getTextKey('consumption.overall') | translate: placeholder['consumption']"></p>
        <div class="arrow no-print"><span>{{ 'heizcheck.auswerten.how' | translate }}</span></div>
      </div>
      <div class="cell small-12 medium-6">
        <div class="lighter-gray">
          <div class="image-wrapper no-print">
            <img src="assets/img/sauna-heat.svg" alt="">
          </div>
          <h3>{{'heizcheck.auswerten.consumption.heating' | translate}}</h3>
          <p [innerHTML]="getTextKey('consumption.heating') | translate: placeholder['consumption_heating'] | safeHtml"></p>
        </div>
      </div>
      <div class="cell small-12 medium-6">
        <div class="lighter-gray">
          <div class="image-wrapper no-print">
            <img src="assets/img/shower-person.svg" alt="">
          </div>
          <h3>{{'heizcheck.auswerten.consumption.water' | translate}}</h3>
          @if (decentralizedWaterHeating === false) {
            <p [innerHTML]="getTextKey('consumption.water') | translate: placeholder['consumption_water'] | safeHtml"></p>
          }
          @if (decentralizedWaterHeating === true) {
            <p [innerHTML]="'heizcheck.auswerten.consumption.water.dezentral' | translate: placeholder['consumption_water'] | safeHtml"></p>
          }
        </div>
      </div>
    </div>
    @if (hideTipps === false) {
      <app-tipps [hideCta]="!internalPortal" [tipps]="tipps['consumption']" [tippCountDefault]="3" [headline]="'heizcheck.auswerten.consumption.tipps.headline'" [imagePath]="'/images/advisor/smarthec/'"></app-tipps>
    }
    @if (placeholder['co2']['co2']) {
      <app-co2info [teaser]="'heizcheck.auswerten.consumption.co2.teaser'" [text]="'heizcheck.auswerten.consumption.co2.text'" [placeholder]="placeholder['co2']"></app-co2info>
    }
  </section>
  @if (forceDialog) {
    <section class="dialogform-wrapper">
      <app-dialogform textkeyPrefix="heizcheck" copyright=".dialogform.copyright" advisorImagePath="/hec/hec-lead.svg" textkeyPostfix="|heizkostenabrechnung" [registrationData]="dialogData" (onDialogRegister)="dialogRegistered($event)" [downloadUrl]="reportUrl"></app-dialogform>
    </section>
  }
  <section class="energy">
    <h2 [innerHTML]="'heizcheck.auswerten.section.energy.headline' | translate" class="box-headline print-break-before"></h2>
    <p [innerHTML]="energyTeaser | translate: placeholder['energy'] | safeHtml"></p>
    <div class="consumption-image energy">
      <div class="signal3">
        <span [innerHTML]="getTextKey('energy.overall', 'label') | translate"></span><br>
        <span [class]="'resultmarker-' + getResult('energy.overall')">{{sign(placeholder['energy']['eur_rare'])}}{{placeholder['energy']['eur']}}€</span>
      </div>
      <img src="/gfx/hec/apartment-building-orange.svg" alt="">
      <img src="/gfx/hec/apartment-building-grey.svg" alt="">
      <span class="label" [innerHTML]="'heizcheck.auswerten.energy.average' | translate"></span>
    </div>
    <app-helptext [helptextId]="'help-average'" [icon]="'icon-robot'" [buttontext]="'heizcheck.auswerten.energy.help.avarage.button'" [helptext]="'heizcheck.auswerten.energy.help.avarage.help'"></app-helptext>
    <div class="grid-x grid-margin-x section-result">
      <div class="cell small-12 top">
        <p class="secondary" [class]="'resultmarker-' + getResult('energy.overall')" [innerHTML]="getTextKey('energy.overall') | translate: placeholder['energy']"></p>
        <div class="arrow no-print"><span>{{ 'heizcheck.auswerten.how' | translate }}</span></div>
      </div>
      <div class="cell small-12 medium-6">
        <div class="lighter-gray">
          <div class="image-wrapper no-print">
            <img src="assets/img/gas-latern.svg" alt="">
          </div>
          <h3>{{'heizcheck.auswerten.energy.price' | translate}}</h3>
          <p [innerHTML]="getTextKey('energy.price') | translate: placeholder['energy_price'] | safeHtml"></p>
        </div>
      </div>
      <div class="cell small-12 medium-6">
        <div class="lighter-gray">
          <div class="image-wrapper no-print">
            <img src="assets/img/tool.svg" alt="">
          </div>
          <h3>{{'heizcheck.auswerten.energy.costs' | translate}}</h3>
          <p [innerHTML]="getTextKey('energy.costs') | translate: placeholder['energy_costs'] | safeHtml"></p>
        </div>
      </div>
    </div>
    @if (forecastData) {
      <div class="callout lighter-gray costs-compare-wrapper hka">
        <app-forecast-chart
          [anfrage]="anfrage"
          [placeholder]="placeholder"
          [dataCases]="dataCases"
          [compareData]="compareData"
          [forecastData]="forecastData"
          [hints]="hints"
          (hintToggled)="toggleHint($event)"
          mode="hka"
          textkeyPrefix="heizcheck.auswerten.heizkostenvergleich">
        </app-forecast-chart>
      </div>
    }
  </section>
  <section class="building">
    <h2 [innerHTML]="'heizcheck.auswerten.section.building.headline' | translate" class="box-headline print-break-before"></h2>
    <p [innerHTML]="'heizcheck.auswerten.building.teaser' | translate | safeHtml"></p>
    <app-helptext [helptextId]="'help-building'" [down]="true" [icon]="'icon-robot'" [buttontext]="'heizcheck.auswerten.building.help.color.button'" [helptext]="'heizcheck.auswerten.building.help.color.help'"></app-helptext>
    <app-building-condition [textPlaceholder]="placeholder['building']" textKeyPrefix="heizcheck.verbrauchsanalyse.ergebnis.condition" [value]="placeholder['building']['evkw']" [min]="placeholder['building']['evkw_min']" [max]="placeholder['building']['evkw_max']" [avg]="placeholder['building']['evkw_avg']" [showAverage]="false"></app-building-condition>
    <div class="grid-x grid-margin-x section-result">
      <div class="cell small-12 top">
        <p class="secondary" [class]="'resultmarker-' + getResult('building.overall')" [innerHTML]="getTextKey('building.overall') | translate: placeholder['building']"></p>
        <div class="arrow no-print"><span>{{ 'heizcheck.auswerten.how' | translate }}</span></div>
      </div>
      <div class="cell small-12">
        <div class="lighter-gray single">
          <div class="image-wrapper no-print">
            <img src="assets/img/construction.svg" alt="">
          </div>
          <div>
            <p [innerHTML]="getTextKey('building.condition', getResult('building.condition') === '-1' && oldBuilding? 'altbau' : null) | translate: placeholder['building'] | safeHtml"></p>
            @if (isFossilEnergySource) {
              <p [innerHTML]="('heizcheck.auswerten.building.condition.co2' + (placeholder['building']['splitting_vermieter'] === 0? '.fossil.0percent' : '.fossil')) | translate: placeholder['building'] | safeHtml"></p>
            }
            @else {
            <p [innerHTML]="('heizcheck.auswerten.building.condition.co2' + (isDistrictHeating ? '.district.heating' : '')) | translate: placeholder['building'] | safeHtml"></p>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="print-break-before"></div>
  <div class="list tipps download-wrapper">
    <h3 class="text-center" [innerHTML]="'heizcheck.auswerten.building.tipps.headline' | translate"></h3>
    <div class="grid-x grid-padding-x">
      <div class="cell large-6 image show-for-large no-print">
        <span class="copyright" [innerHTML]="'heizcheck.auswerten.building.tipps.copyright' | translate"></span>
      </div>
      <div class="cell large-6">
        <div [innerHTML]="'heizcheck.auswerten.building.tipps.text' | translate"></div>
        @if (anfrage.heizkostenanalyseResult?.result?.report_letter) {
          <div class="download-preview no-print">
            <img src="/gfx/hec/vorschau-anschreiben.png" alt="">
            <a class="button" target="_blank" [href]="anfrage.heizkostenanalyseResult.result.report_letter"><i class="icon-download" [attr.aria-label]="'arialabel.download.icon' | translate"></i><span [innerHTML]="'heizcheck.auswerten.building.tipps.letter.download' | translate"></span></a>
          </div>
        }
        @if (anfrage.heizkostenanalyseResult?.result?.report_appendix) {
          <div class="download-preview no-print">
            <img src="/gfx/hec/vorschau-datenblatt.png" alt="">
            <a class="button" target="_blank" [href]="anfrage.heizkostenanalyseResult.result.report_appendix"><i class="icon-download" [attr.aria-label]="'arialabel.download.icon' | translate"></i><span [innerHTML]="'heizcheck.auswerten.building.tipps.data.download' | translate"></span></a>
          </div>
        }
      </div>
    </div>
  </div>
</section>
@if (!hideReportDownload && reportUrl && !internalPortal) {
  <section class="download-wrapper">
    <app-download [url]="reportUrl" textkeyPrefix="heizcheck.auswerten."></app-download>
  </section>
}
<app-portal-teaser></app-portal-teaser>
@if (internalPortal === true) {
  <section>
    <app-donate textkeyPrefix="heizcheck"></app-donate>
  </section>
}
}


@if (hasData) {
  <app-step-buttons [previousLink]="previousPage" leftAlignSize="small" previousText="step.button.previous" [nextLink]="null" [nextSubmit]="false"></app-step-buttons>
}
